import { UploadPieceJointeFormValues } from './types';

export function getInitialsValues(): UploadPieceJointeFormValues {
  return {
    type: undefined,
    file: undefined,
  };
}
